import { Component, OnInit } from '@angular/core';
import {ChartsModule}  from 'ng2-charts';
import { ChartConfiguration, ChartType } from 'chart.js';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { GraficiService } from 'src/app/services/grafici/grafici.service';
import { GenericResponse,Bilancio } from 'src/app/entities/various';
import { newArray } from '@angular/compiler/src/util';





export interface ChartOptions {
  scaleShowVerticalLines: boolean,
  responsive: boolean,
  tooltips: {
    backgroundColor: string,
    titleFontColor: string,
    bodyFontColor: string}
};

export interface DatiGrafico{
  data : any[], //valori del grafico
  label: string //nome es Totale Attivo,
  backgroundColor: string,
  hoverBackgroundColor: string
};


export interface Grafico{
  type: ChartType,
  options : ChartOptions,
  labels : string[]
  dati : DatiGrafico[],
  legend : boolean,
  totale_positivo : string,
  totale_negativo : string,
 };

 export interface Anni{
  anni_disponibili : string[],
  anno_selezionato : string
 }



@Component({
  selector: 'app-grafici',
  templateUrl: './grafici.component.html',
  styleUrls: ['./grafici.component.css']
})



export class GraficiComponent implements OnInit {

    public graficoTotali : Grafico | undefined;
    public graficoIva : Grafico | undefined;
    public barChartPlugins = [{ beforeInit: function(chart : any, options : any) {
                                    //console.log(chart);
                                    chart.options.tooltips.callbacks.title= function(tooltipItem : any, data : any) {
                                      return data['labels'][tooltipItem[0]['index']];
                                    },
                                    chart.options.tooltips.callbacks.label= function(tooltipItem: any, data : any) {
                                      return  Number(tooltipItem.value).toFixed(2)+ ' €';
                                    }
                                  }
                                }]

    public graficoIvaLoader : boolean = false;
    public graficoTotaliLoader : boolean = false;

    public anniGrafici : Anni | undefined;
    
    public totaliMode : string = 'ANNO';
    public ivaMode : string = 'ANNO';
    public ivaViewMode : string = 'GRAFICO';

    public bilancio : Bilancio | undefined;


  constructor(private dashboardService : DashboardService,
              public translate: TranslateService,
              private graficiService: GraficiService) { }

  async ngOnInit() {
    this.anniGrafici = {'anno_selezionato': this.getAnnoCorrente(), 'anni_disponibili': this.getAnniDisponibili()};

    this.bilancio  = await this.graficiService.getRiepilogoIva();
    //console.log(this.bilancio);
    if(this.bilancio != undefined) {
      this.initGrafici();
    }
  }


  initGrafici(){
    this.initIvaChart('anno_corrente');
    this.initTotaleChart('anno_corrente');
  }

  annoIvaChange(event :any){
    let anno=this.anniGrafici!.anno_selezionato;
    return this.initIvaChart(this.getStringaAnno(anno!));
  }

  getStringaAnno(anno_selezionato: string){
    if(anno_selezionato==this.getAnnoCorrente())
            return 'anno_corrente';
    if(Number(anno_selezionato)== (Number(this.getAnnoCorrente())-1))
            return 'anno_1';
        else return 'anno_2';
  }

  annoTotaleChange(event:any){
    let anno=this.anniGrafici!.anno_selezionato;
   // return this.initTotaleChart(this.getStringaAnno(anno!));
   this.initTotaleChart(this.getStringaAnno(anno!));
   this.initIvaChart(this.getStringaAnno(anno!));
  }

  initIvaChart(anno:string){
    let passiveArr= this.elaboraDatiAnno('fep_'+anno+'_iva',this.ivaMode);
    let attiveArr = this.elaboraDatiAnno('fea_'+anno+'_iva',this.ivaMode);
    let datiGraficoIVACredito: DatiGrafico = { 'data' : passiveArr,
                                    'label' : 'Iva Credito','backgroundColor': '#008000b8','hoverBackgroundColor':'green'};   
    let datiGraficoIVADebito: DatiGrafico = { 'data' :attiveArr,
                                    'label' : 'Iva Debito', 'backgroundColor': '#ff0000ad','hoverBackgroundColor':'red'}
    let dati : DatiGrafico[]=[datiGraficoIVACredito,datiGraficoIVADebito];
    this.graficoIva={
        'type':'bar',
        'legend':true,
        'labels': this.getLabels(this.ivaMode),
        'dati': dati,
        'options': {'scaleShowVerticalLines':true, 'responsive': true, tooltips  : {backgroundColor: '#ffff',titleFontColor:'#000',bodyFontColor:'#000'}},
        'totale_negativo': this.calcolaSomma(attiveArr),
        'totale_positivo': this.calcolaSomma(passiveArr),
    };
    this.graficoIvaLoader=false;
  }

  initTotaleChart(anno : string){
    let attiveArr= this.elaboraDatiAnno('fea_'+anno+'_totale',this.totaliMode);
    let passiveArr = this.elaboraDatiAnno('fep_'+anno+'_totale',this.totaliMode);

    let datiGraficoCredito: DatiGrafico = { 'data' : attiveArr,
                                    'label' : 'Fattura Attive','backgroundColor': '#008000b8','hoverBackgroundColor':'green'};

    let datiGraficoDebito: DatiGrafico = { 'data' :passiveArr,
                                    'label' : 'Fatture Passive', 'backgroundColor': '#ff0000ad','hoverBackgroundColor':'red'};
    let dati : DatiGrafico[]=[datiGraficoCredito,datiGraficoDebito];
    this.graficoTotali={
        'type':'bar',
        'legend':true,
        'labels': this.getLabels(this.totaliMode),
        'dati': dati,
        'options': {'scaleShowVerticalLines':true, 'responsive': true, tooltips  : {backgroundColor: '#ffff',titleFontColor:'#000',bodyFontColor:'#000'}},
        'totale_negativo': this.calcolaSomma(passiveArr),
        'totale_positivo': this.calcolaSomma(attiveArr),
    };
    this.graficoTotaliLoader=false;
  }



 
  getAnniDisponibili(){
    let anno_corrente=(new Date()).getFullYear();
    return [(anno_corrente-2).toString(),(anno_corrente-1).toString(),anno_corrente.toString()];
  }

  getAnnoCorrente(){
    return (new Date()).getFullYear().toString();
  }

  getLabels(mode:string){
    if(mode=='ANNO')
        return ['Gen','Feb','Mar','Apr','Mag','Giu','Lug','Ago','Set','Ott','Nov','Dic'];
    else
      return ['Gen - Mar','Apr - Giu','Lug - Set','Ott - Dic'];
  }

  
  

  elaboraDatiAnno(campo: any,mode: string){
    try {
          var data= this.bilancio![campo as keyof Bilancio];
          let array= this.trasformaJson(data as string);
          if(mode=='ANNO'){
                  for(var i=0;i< array.length; i++)
                      array[i]=Number(array[i]).toFixed(2);
                  
                  return array;
          }else{
           // console.log(array);
            let trimestri=new Array();
            trimestri[0]=(Number(array[0]) + Number(array[1]) + Number(array[2])).toFixed(2);
            trimestri[1]=(Number(array[3]) + Number(array[4]) + Number(array[5])).toFixed(2);
            trimestri[2]=(Number(array[6]) + Number(array[7]) + Number(array[8])).toFixed(2);
            trimestri[3]=(Number(array[9]) + Number(array[10]) + Number(array[11])).toFixed(2);
          //  console.log(trimestri);
            return trimestri;
          }
    }catch(e){
      console.log(e);
      return [];
    }
  }

  /* prende in input una stringa del tipo "{\"01\":0,\"02\":0,\"03\":0,\"04\":0,\"05\":0,\"06\":0,\"07\":0,\"08\":0,\"09\":0,\"10\":216.25,\"11\":0,\"12\":0}"
  e la trasforma in un normale array*/
  trasformaJson(data :string){
    let oggetto=JSON.parse(data as string);
    var arrayValoriOrdinati = Object.keys(oggetto)
          .map(function(key) {
              return {
                  chiaveIntera: parseInt(key, 10), // Converte la chiave in un numero intero
                  valore: oggetto[key] // Ottieni il valore corrispondente
              };
          })
        .sort(function(a, b) {
            return a.chiaveIntera - b.chiaveIntera; // Ordina in base alla chiave intera
        })
        .map(function(item) {
            return item.valore; // Estrai solo i valori ordinati
        });

        if(arrayValoriOrdinati.length!=12)
            return new Array("","","","","","","","","","","","");
        return arrayValoriOrdinati;
  }

    calcolaSomma(array: any[]): string {
      let somma=0;
      for (let i = 0; i < array.length; i++) {
        somma += Number(array[i]);
      }
      return somma.toFixed(2).toString();
  }


  setIvaMode(mode :string){
    if(mode==this.ivaMode)
          return;
    this.ivaMode=mode;
    this.initIvaChart(this.getStringaAnno(this.anniGrafici!.anno_selezionato))
  }

  setTotaliMode(mode :string){
    if(mode==this.totaliMode)
          return;
    this.totaliMode=mode;
    this.initTotaleChart(this.getStringaAnno(this.anniGrafici!.anno_selezionato));
  }

  onChartHover(event : any){
    //console.log(event);
  }

  cambiaVistaIva(){
    if( this.ivaViewMode=='GRAFICO')
          this.ivaViewMode='TABELLA';
    else this.ivaViewMode='GRAFICO';
  }

  comparaValoriNumerici(a : any, b:any){
      if(Number(a) >= Number(b))
        return true;
      return false;
  }


}
